import React, { useState, useContext, useEffect, useRef } from "react";
import { DashboardContext } from "../../../context/DashboardContext";
import { WebSocketContext } from "../../../context/WebSocketContext";
import { GraphContext } from "../../../context/GraphContext";
import { GeneralContext } from "../../../context/GeneralContext";
import { useTutorialProgress } from "../../../context/TutorialContext";
import { AuthContext } from "../../../context/AuthContext";
import BlockingOverlay from "../../commonComponents/BlockingOverlay";
import {
  hasParentOrChildWithID,
  getModelById,
  replaceModelById,
  setLinked,
  deleteModelByID,
  addSubModelToModels,
  unlinkModelList,
  refreshLinks,
  createModelsForDisplay,
  deepCopy,
  updateDisplayName,
  isDescendant,
  constructModelList,
  generateModel,
  linkedSubModelAdd,
  createModelFromParamList,
  collectClashingGroupsFromNonRecParams,
  collectClashingGroupsFromRecParams,
  collectClashingGroupsLineshapes,
  allContainedGroups,
  updateRecParamsAndRows,
  convertModelFormat,
  getParentModelFromIndexChain,
  updateGroupsAfterLinking,
//  linkSubmodel,
//  loadModelFromFile,
  loadExperimentFromFile,
} from "./modelLogic";
import Modal from "react-modal";
import {
  handleFileChange,
  generateWarningObject,
  hasProperty,
  updateModelsOnGroupChanges,
  simpleReadFile,
  adjustModalPositionAndSize,
  vwToPixels,
  //  arrayBufferToBase64,
  isDeepEqual,
  produceListOfExchangeableModels,
  getShortName,
//  convertBEParameterToFE,
  //  getAllIdsForModelsAndSubmodels,
  //   getModelsLinkedExceptGiven,
  getParsedModelListFromJson,
  updateGroupsOnModelChanges,
} from "../../../utils/helpers";
import "./../leftSide.scss";
import GroupClashWindow from "./GroupClashWindow";
// import {
//   getSubModelIdList,
//   // getUpdatedUniqueIds,
// } from "../../rightSide/parameters/parameterLogic";
import ModelExchange from "../../rightSide/parameters/ModelExchange";
import CustomButton from "../../commonComponents/CustomButton";
import MaterialDBModal from "./MaterialDBModal";

export default function Models() {
  const {
    modelData,
    setModelData,
    modelNextID,
    setModelNextID,
    abbrDic,
    setAbbrDic,
    namingDic,
    setNamingDic,
    setAllLocalModels,
    allLocalModels,
    allLocalLineshapes,
    setWarnings,
    setNewWarningCount,
    setUndoModels,
    valueGroups,
    setValueGroups,
    setParamWindowPosAndSize,
    setCheckParamPositions,
    addSubModTitle,
  } = useContext(DashboardContext);
  const {
    lastJsonMessage,
    sendJsonMessage,
    isFitOngoing,
    isLoopOngoing,
    retrieveRequestData,
    deleteRequestDataEntry,
  } = useContext(WebSocketContext);
  const {
    setUpdatedModelFE_IDs,
    graphs,
    setGraphs,
    // chi2Terms,
    setChi2Terms,
    setSelectedChi2Terms,
  } = useContext(GraphContext);
  const { limitedToast, limitedWarningToast, recordedErrorLog } =
    useContext(GeneralContext);
  const { currentUser, isAuthReady } = useContext(AuthContext);
  const { monitorStateChange } = useTutorialProgress();
  const [linkingActive, setLinkingActive] = useState(false);
  // const [linkingID, setLinkingID] = useState(null);
  // const [linkingSpeqqleID, setLinkingSpeqqleID] = useState(null);
  const linkingID = useRef(null);
  const linkingSpeqqleID = useRef(null);
  let modelsAfterUnlink = [];
  let idAfterUnlink = 0;
  // let modelsForDisplay = [];
  let allModelsReceived = [];
  const [modelsToDisplay, setModelsToDisplay] = useState([]);
  const modelsRef = useRef(null);
  const localModelsDataRef = useRef(null);
  const [modalList, setModalList] = useState(null);
  // const [allModels, setAllModels] = useState(null);
  const allModels = useRef(null);
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalPlaceAndSize, setModalPlaceAndSize] = useState({
    top: "0",
    left: "0",
    height: "300px",
    width: "300px",
  });
  const [clashModalIsOpen, setClashModalIsOpen] = useState(false);
  const [materialDBModalIsOpen, setMaterialDBModalIsOpen] = useState(false);
  const fileInputRef = useRef(null);

  const [clashingModel, setClashingModel] = useState(null);
  const [clashingGroups, setClashingGroups] = useState(null);
  const [upadatedGroupsWithNoClash, setUpdatedGroupsWithNoClash] =
    useState(null);
  const [isLinkOpen, setIsLinkOpen] = useState(false);
  const [linkingOptions, setLinkingOptions] = useState([]);
  const currentID = useRef(modelNextID);
  const localAbbrDic = useRef(abbrDic);
  const allLocalLineshapesRef = useRef(allLocalLineshapes);
  const modelListRef = useRef();

  useEffect(() => {
    // Skip if no lineshapes are available or no models to process

    if (
      !allLocalLineshapes ||
      allLocalLineshapes.length === 0 ||
      modelData.length === 0
    )
      return;

    let modelsUpdated = false;
    const updatedModelData = deepCopy(modelData);

    // Recursive function to process models and their submodels
    const processModel = (model) => {
      // Process submodels recursively first
      if (model.subModels && model.subModels.length > 0) {
        model.subModels = model.subModels.map((subModel) =>
          processModel(subModel)
        );
      }

      // Skip if model doesn't have lineshape data
      if (!hasProperty(model, "lineshapeData")) return model;
      // Check each lineshape for missing templates
      for (let i = 0; i < model.lineshapeData.length; i++) {
        const lineshape = deepCopy(model.lineshapeData[i]);

        // Skip if this lineshape already has a template
        if (hasProperty(lineshape, "lineTemplate")) continue;

        // Try to find template in allLocalLineshapes
        let template = undefined;
        if (allLocalLineshapes) {
          template = allLocalLineshapes.find(
            (t) => t.lineshape_id === lineshape.lineshape_id
          );
        }
        // Skip if no template found or template doesn't have lineTemplate
        if (!template || !hasProperty(template, "lineTemplate")) continue;

        // Apply the template to the lineshape
        lineshape.lineTemplate = deepCopy(template.lineTemplate);
        lineshape.lineTableRows = [];
        // Process the lineshape parameters with the template
        for (let j = 0; j < lineshape.lineParams.length; j++) {
          let row = {};
          let params = [];

          for (let k = 0; k < lineshape.lineParams[j].length; k++) {
            const lineParam = lineshape.lineParams[j][k];
            let tempParam = lineshape.lineTemplate.params.find(
              (param) => param.speqqle_id === lineParam.speqqle_id
            );

            if (tempParam) {
              // Create a deep copy to avoid reference issues
              tempParam = deepCopy(tempParam);

              // Apply values from line params
              tempParam.value = lineParam.value;
              tempParam.customFixed = tempParam.fixed;

              // Handle additional properties like group, hardMin/Max
              if (hasProperty(lineParam, "group")) {
                tempParam.group = lineParam.group;
              } else if (hasProperty(lineParam, "matched")) {
                tempParam.group = lineParam.matched;
              }

              if (hasProperty(lineParam, "hardmax")) {
                tempParam.hardMax = lineParam.hardmax;
              }

              if (hasProperty(lineParam, "hardmin")) {
                tempParam.hardMin = lineParam.hardmin;
              }
              if (hasProperty(lineParam, "customFixed")) {
                tempParam.customFixed = lineParam.customFixed;
              } else if (hasProperty(lineParam, "fixed")) {
                tempParam.customFixed = lineParam.fixed;
              }
              // Add to processed parameters and row
              params.push(tempParam);
              row[tempParam.name] = tempParam.value;
            }
          }

          // Add processed row to lineTableRows
          lineshape.lineTableRows.push(row);

          // Replace original parameters with processed ones
          lineshape.lineParams[j] = params;
        }
        model.lineshapeData[i] = lineshape;
        // Mark that we've made changes
        modelsUpdated = true;
      }

      return model;
    };

    // Process all models in our data
    for (let i = 0; i < updatedModelData.length; i++) {
      updatedModelData[i] = processModel(updatedModelData[i]);
    }

    // Update state if we made changes
    if (modelsUpdated) {
      setModelData(updatedModelData);
    }
  }, [allLocalLineshapes]);

  useEffect(() => {
    if (!isDeepEqual(abbrDic, localAbbrDic.current)) {
      localAbbrDic.current = abbrDic;
    }
  }, [abbrDic]);

  useEffect(() => {
    if (!isDeepEqual(allLocalLineshapes, allLocalLineshapesRef.current)) {
      allLocalLineshapesRef.current = allLocalLineshapes;
    }
  }, [allLocalLineshapes]);

  useEffect(() => {
    if (currentID.current !== modelNextID) {
      currentID.current = modelNextID;
    }
  }, [modelNextID]);

  // const requestedBinary = useRef([]);

  const checkIfBatchContainsLinked = (indexChain, isClickedModelLinked) => {
    const parentModel = getParentModelFromIndexChain(modelData, indexChain);
    const subModelsPerLine = parentModel?.subModelTypes.length;

    if (subModelsPerLine === 1 || isClickedModelLinked) {
      return isClickedModelLinked;
    }

    const indexChainInt = indexChain.split(";").map((index) => parseInt(index));
    const indexOfClickedModel = indexChainInt[indexChainInt.length - 1];

    const startIndex =
      Math.floor(indexOfClickedModel / subModelsPerLine) * subModelsPerLine;
    const endIndex = startIndex + subModelsPerLine;

    for (let i = startIndex; i < endIndex; i++) {
      const currentSubMod = parentModel.subModels[i];

      if (currentSubMod.linked) {
        return true;
      }
    }

    return false;
  };

  const handleUnlinkingBeforeDelete = (indexChain) => {
    const parentModel = getParentModelFromIndexChain(modelData, indexChain);
    const subModelsPerLine = parentModel?.subModelTypes.length;
    if (parentModel === null || subModelsPerLine === 1) {
      unlinkModel(indexChain);
    } else {
      const indexChainInt = indexChain
        .split(";")
        .map((index) => parseInt(index));
      const indexOfClickedModel = indexChainInt[indexChainInt.length - 1];

      const startIndex =
        Math.floor(indexOfClickedModel / subModelsPerLine) * subModelsPerLine;
      const endIndex = startIndex + subModelsPerLine;

      let isFirstUnlink = true;

      for (let i = startIndex; i < endIndex; i++) {
        const currentSubMod = parentModel.subModels[i];

        if (currentSubMod.linked) {
          let indexChainToSend = deepCopy(indexChainInt);
          indexChainToSend[indexChainToSend.length - 1] = i;
          indexChainToSend = indexChainToSend.join(";");

          if (isFirstUnlink) {
            unlinkModel(indexChainToSend, false);
            isFirstUnlink = false;
          } else {
            unlinkModel(indexChainToSend, true);
          }
        }
      }
    }
  };

  useEffect(() => {
    const modelsForDisplay = createModelsForDisplay(
      modelData,
      renameModel,
      startLinking,
      isLinkActive,
      deleteModel,
      addSubModel,
      unlinkModel,
      canLink,
      namingDic,
      linkingID.current,
      handleUnlinkingBeforeDelete,
      checkIfBatchContainsLinked,
      null
    );
    if (!isDeepEqual(modelsForDisplay, modelsToDisplay)) {
      monitorStateChange("model_list_updated", {
        modelsList: modelsForDisplay,
        modelData: modelData,
      });
    }
    setModelsToDisplay(modelsForDisplay);
  }, [modelData, namingDic, linkingActive]);

  useEffect(() => {
    if (clashingModel !== null) {
      setClashModalIsOpen(true);
    }
  }, [clashingModel]);

  useEffect(() => {
    localModelsDataRef.current = modelData;
  }, [modelData]);

  //Creating a local abbreviation dictionary here, since the useState setter is not
  //setting the value fast enough for it to be used in multi level depth sub model generation
  //the context is still being updated, in case the value needs to be accessed from other parts and
  //it allows for names to stay the same during page refresh or "Models" window closing and opening
  // let localAbbrDic = abbrDic;
  function getAbbrDic() {
    return localAbbrDic.current;
  }

  function setLocalAbbrDic(changedAbbrs) {
    localAbbrDic.current = changedAbbrs;
    setAbbrDic(localAbbrDic.current);
  }

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleCloseClashModal = () => {
    setClashModalIsOpen(false);
  };

  const handleOpenMaterialDB = () => {
    setMaterialDBModalIsOpen(true);
  };

  const handleCloseMaterialDB = () => {
    setMaterialDBModalIsOpen(false);
  };

  // let currentID = modelNextID;

  function getID() {
    return currentID.current;
  }

  function upID() {
    currentID.current = currentID.current + 1;
    setModelNextID(currentID.current);
  }

  const handleModalEntryClick = (speqqleID) => {
    try {
      const generatedModel = generateModel(
        addSubModTitle,
        speqqleID,
        getID,
        upID,
        getAbbrDic,
        setLocalAbbrDic,
        allModelsReceived,
        namingDic,
        setNamingDic,
        false,
        recordedErrorLog,
        allLocalLineshapesRef.current,
        currentUser,
        sendJsonMessage,
        false
      );
      const modelDataToChange = deepCopy(localModelsDataRef.current);
      modelDataToChange.push(generatedModel);
      setModelData(modelDataToChange);

      // Check if this is a Raman model (speqqleID === -113) and update tutorial
      monitorStateChange("model_created", {
        modeltype: speqqleID,
        modelID: generatedModel.FE_ID,
        model: generatedModel,
      });

      handleCloseModal();
    } catch (error) {
      recordedErrorLog("Modal entry click handler failure: ", error);
    }
  };

  function handleModelListReponse(jsonMessage) {
    try {
      const listOfSpeqqleIDs = jsonMessage.Model.ModelList.map(
        (entry) => entry.speqqle_id
      );
      sendJsonMessage(
        {
          User: currentUser.id,
          Model: { GetModelSpecs: listOfSpeqqleIDs },
        },
        { type: "get-model-specs" }
      );
      allModels.current = jsonMessage.Model.ModelList;
    } catch (error) {
      recordedErrorLog("Error handling model LIST response: ", error);
    }
  }

  function handleModelSpecsReponse(jsonMessage) {
    try {
      let allModelsCopy = deepCopy(allModels.current);
      allModelsCopy = allModelsCopy.map((model) => {
        const selectedDetails = jsonMessage.Model.ModelSpecs.find(
          (details) => details.SpeqqleModelID == model.speqqle_id
        );

        // Create the base model object
        let updatedModel = {
          ...model,
          params: selectedDetails.Parameters,
          outputs: selectedDetails.Outputs,
        };

        // Add shapes only if the list is not empty
        if (selectedDetails.Shapes && selectedDetails.Shapes.length > 0) {
          updatedModel.shapes = selectedDetails.Shapes;
        }

        return updatedModel;
      });
      allModelsReceived = deepCopy(allModelsCopy);
      allModels.current = allModelsCopy;
      setAllLocalModels(allModelsCopy);

      setModalList(constructModelList(allModelsCopy, handleModalEntryClick));
      setLoading(false);
      let lineshapesToAdd = [];
      let allLineshapesCopy = deepCopy(allLocalLineshapes);
      for (let i = 0; i < allModelsCopy.length; i++) {
        if (hasProperty(allModelsCopy[i], "shapes")) {
          for (let j = 0; j < allModelsCopy[i].shapes.length; j++) {
            let shapeid = allModelsCopy[i].shapes[j].speqqle_id;
            if (
              !lineshapesToAdd.some((id) => id === shapeid) &&
              !allLineshapesCopy.some(
                (lineshape) => lineshape.lineshape_id === shapeid
              )
            ) {
              lineshapesToAdd.push(shapeid);
            }
          }
        }
      }
      if (lineshapesToAdd.length > 0) {
        sendJsonMessage(
          {
            User: currentUser.id,
            Model: { GetShapeSpecs: lineshapesToAdd },
          },
          { type: "get-shape-specs-app-bar" }
        );
      }
    } catch (error) {
      recordedErrorLog("Error handling model SPECS response: ", error);
    }
  }

  function generateModelForParams(speqqleID) {
    const generatedModel = generateModel(
      addSubModTitle,
      speqqleID,
      getID,
      upID,
      getAbbrDic,
      setLocalAbbrDic,
      allModels.current,
      namingDic,
      setNamingDic,
      false,
      recordedErrorLog,
      allLocalLineshapesRef.current,
      currentUser,
      sendJsonMessage,
      false
    );

    return generatedModel;
  }

  // function handleBinaryModelReponse(jsonMessage, details) {
  //   try {
  //     const newModels = [];
  //     let requestedIds = details.requestedIds;

  //     for (let i = 0; i < jsonMessage.Model.SendModel.length; i++) {
  //       let modelFromBinary = jsonMessage.Model.SendModel[i];
  //       modelFromBinary = convertModelFormat(modelFromBinary);

  //       let isFirstRequest = true;

  //       const binaryGetId = () => {
  //         if (isFirstRequest) {
  //           isFirstRequest = false;
  //           return modelFromBinary.modelid;
  //         }

  //         return getID();
  //       };

  //       const generatedModel = generateModel(
  //         addSubModTitle,
  //         modelFromBinary.modeltype,
  //         binaryGetId,
  //         upID,
  //         getAbbrDic,
  //         setLocalAbbrDic,
  //         allModels.current,
  //         namingDic,
  //         setNamingDic,
  //         false,
  //         recordedErrorLog,
  //         allLocalLineshapes,
  //         currentUser,
  //         sendJsonMessage,
  //         false
  //       );
  //       const filledModelWithParams = createModelFromParamList(
  //         modelFromBinary,
  //         generatedModel,
  //         generateModelForParams,
  //         sendJsonMessage,
  //         currentUser,
  //         allLocalLineshapes
  //       );

  //       newModels.push(filledModelWithParams);

  //       requestedIds = requestedIds.filter(
  //         (id) => id !== modelFromBinary.modelid
  //       );
  //     }

  //     setModelData((oldData) => [...oldData, ...newModels]);

  //     if (requestedIds.length > 0) {
  //       throw new Error(
  //         "Not all requested binary models were returned from the BE"
  //       );
  //     }
  //   } catch (error) {
  //     recordedErrorLog("Error handling binary model load response: ", error);
  //   }
  // }

  useEffect(() => {
    try {
      if (lastJsonMessage) {
        const processingJsonMessage = deepCopy(lastJsonMessage);
   
        if (hasProperty(processingJsonMessage, "requestID")) {
          const requestData = retrieveRequestData(processingJsonMessage.requestID);
          if (requestData !== null) {
            switch (requestData.type) {
              case "get-model-list":
                handleModelListReponse(processingJsonMessage);
                deleteRequestDataEntry(processingJsonMessage.requestID);
                break;
              case "get-model-specs":
                handleModelSpecsReponse(processingJsonMessage);
                deleteRequestDataEntry(processingJsonMessage.requestID);
                break;
              // case "binary-model-load":
              //   handleBinaryModelReponse(lastJsonMessage, requestData);
              //   deleteRequestDataEntry(lastJsonMessage.requestID);
              //   break;

              default:
                break;
            }
          }
        } else {
          throw new Error("Request ID was not attached to the json message.");
        }
      }
    } catch (error) {
      recordedErrorLog(
        "Last Json message handling failure in useEffect: ",
        error
      );
    }
  }, [lastJsonMessage]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        modelsRef.current &&
        !modelsRef.current.contains(event.target) &&
        !isDescendant(event.target)
      ) {
        setLinkingActive(false);
        // setLinkingID(null);
        linkingID.current = null;
      }
    }

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [modelsRef]);

  useEffect(() => {
    if (allLocalModels.length < 1) {
      sendJsonMessage(
        { User: currentUser.id, Model: { GetModelList: [] } },
        { type: "get-model-list" }
      );
      setLoading(true);
    } else {
      // setAllModels(allLocalModels);
      allModels.current = allLocalModels;
      allModelsReceived = deepCopy(allLocalModels);
      setModalList(
        constructModelList(allModelsReceived, handleModalEntryClick)
      );
      setLoading(false);
    }
  }, []);

  function renameModel(newName, ID) {
    setNamingDic({ ...namingDic, [ID]: newName });
    const dataObj = updateDisplayName(modelData, ID, newName);
    setModelData(dataObj.data);
    propagateRenameToGraphs(newName, ID);
    monitorStateChange("model_renamed", {
      modelID: ID,
      modelName: newName,
      model: getModelById(ID, modelData),
    });
  }

  function propagateRenameToGraphs(newName, ID) {
    try {
      let graphsUpdate = deepCopy(graphs);

      graphsUpdate = graphsUpdate.map((graph) => {
        const updatedPlotData = graph.plotData.map((data) => {
          if (hasProperty(data, "modelId") && data.modelId === ID) {
            // Preserve the original naming format: "ModelName: OutputName" or "ModelName&&&&OutputName"
            let updatedName = getShortName(newName);

            // If the original name contains ":" or "&&&&", preserve the output part
            if (data.name.includes(":")) {
              const outputPart = data.name.split(":")[1];
              updatedName = `${newName}:${outputPart}`;
            }
            return { ...data, name: updatedName };
          }
          return data;
        });
        return { ...graph, plotData: updatedPlotData };
      });

      setGraphs(graphsUpdate);
    } catch (error) {
      recordedErrorLog("Rename propagation failure: ", error);
    }
  }

  function deleteModel(ID, unlinked, indexChain) {
    try {
      let idToUse = ID;
      let modelsToUse = deepCopy(modelData);

      if (unlinked) {
        idToUse = idAfterUnlink - 1;
        modelsToUse = modelsAfterUnlink;
      }

      const modelToDelete = getModelById(idToUse, modelsToUse);
      if (!modelToDelete) {
        recordedErrorLog(
          "Model to delete not found: ",
          idToUse,
          false,
          "Model deletion failed",
          { idToUse: idToUse, modelsToUse: modelsToUse }
        );
        return;
      }
      // const containedIdList = getSubModelIdList(modelToDelete);
      let groupsCopy = deepCopy(valueGroups);
      const containedGroupsInModel = allContainedGroups(modelToDelete);
      groupsCopy = groupsCopy.map((group) => {
        if (hasProperty(containedGroupsInModel, group.groupNumber)) {
          const remainingMembers =
            group.memberCount -
            containedGroupsInModel[group.groupNumber].memberCount;
          if (remainingMembers <= 0) {
            return {
              ...group,
              value: null,
              hardMax: null,
              hardMin: null,
              fixed: null,
              memberCount: 0,
            };
          } else {
            return {
              ...group,
              memberCount: remainingMembers,
            };
          }
        } else {
          return group;
        }
      });

      let cleanedList = [];
      if (indexChain.split(";").length === 1) {
        // The main model has been selected for deletion, no need to check sub model things
        const deletionResult = deleteModelByID(modelsToUse, [idToUse]);
        cleanedList = deletionResult.updatedList;
      } else {
        const parentModel = deepCopy(
          getParentModelFromIndexChain(modelsToUse, indexChain)
        );
        const subModelBatchSize = parentModel.subModelTypes.length;

        const modelBatchIds = [];
        const paramRowIndex = Math.floor(
          parseInt(indexChain.split(";").pop()) / subModelBatchSize
        );

        for (let i = 0; i < parentModel.recParams[paramRowIndex].length; i++) {
          const parameter = parentModel.recParams[paramRowIndex][i];

          if (hasProperty(parameter, "FE_ID")) {
            modelBatchIds.push(parameter.FE_ID);
          }
        }

        if (!modelBatchIds.some((id) => id === idToUse)) {
          throw new Error(
            "There was an issue trying to delete sub model batch. The correct index to batch was not found."
          );
        }

        parentModel.recParams.splice(paramRowIndex, 1);
        parentModel.recTableRows.splice(paramRowIndex, 1);

        parentModel.subModels = parentModel.subModels.filter((subModel) => {
          if (modelBatchIds.some((id) => id === subModel.FE_ID)) {
            return false;
          }
          return true;
        });

        cleanedList = replaceModelById(
          modelsToUse,
          parentModel,
          parentModel.FE_ID
        );

        // Add the ID of deleted model parent to ensure any graphs using that model are properly updated
        setUpdatedModelFE_IDs([parentModel.FE_ID]);
      }

      const lookup = refreshLinks(cleanedList);
      setModelData(cleanedList);
      clearGraphsAfterModelDelete(lookup);
      clearChi2AfterModelDelete(lookup);

      //Clearing up positions dictionary from deleted model IDs
      setParamWindowPosAndSize((old) => {
        const updatedDict = deepCopy(old);
        const oldDictKeys = Object.keys(old);
        for (let i = 0; i < oldDictKeys.length; i++) {
          const id = oldDictKeys[i];
          if (!hasProperty(lookup, id)) {
            delete updatedDict[id];
          }
        }

        return updatedDict;
      });
      setCheckParamPositions(true);
      setValueGroups(groupsCopy);
    } catch (error) {
      recordedErrorLog("Model deletion failure: ", error);
    }
  }

  function clearGraphsAfterModelDelete(lookup) {
    const graphsCopy = deepCopy(graphs);
    // we use an object here, because it lets use to do edits with reference not changing in recursive functions
    const update = {
      needed: false,
    };

    clearGraphs(lookup, graphsCopy, update);

    if (update.needed) {
      setGraphs(graphsCopy);
    }
  }

  function clearGraphs(lookup, graphsCopy, update) {
    try {
      for (let i = 0; i < graphsCopy.length; i++) {
        const graph = graphsCopy[i];
        let needsUpdate = false;

        // Filter out containedModels that don't exist in lookup
        if (graph.containedModels && graph.containedModels.length > 0) {
          const filteredModels = graph.containedModels.filter(
            (model) => model.modelId in lookup
          );

          if (filteredModels.length !== graph.containedModels.length) {
            needsUpdate = true;
            graphsCopy[i].containedModels = filteredModels;
          }
        }

        // Filter out plotData entries that don't exist in lookup
        if (graph.plotData && graph.plotData.length > 0) {
          const filteredPlotData = graph.plotData.filter(
            (plot) => !hasProperty(plot, "modelId") || plot.modelId in lookup
          );

          if (filteredPlotData.length !== graph.plotData.length) {
            needsUpdate = true;
            graphsCopy[i].plotData = filteredPlotData;
          }
        }

        if (needsUpdate) {
          update.needed = true;
        }
      }
    } catch (error) {
      recordedErrorLog("Graph clearance failure: ", error);
    }
  }

  // Helper function to collect all model IDs to remove recursively
  // function collectModelIdsToRemove(model, idsArray) {
  //   // Add current model's ID
  //   idsArray.push(model.FE_ID);

  //   // Process all submodels recursively
  //   if (model.subModels && model.subModels.length > 0) {
  //     for (let i = 0; i < model.subModels.length; i++) {
  //       collectModelIdsToRemove(model.subModels[i], idsArray);
  //     }
  //   }

  //   return idsArray;
  // }

  function clearChi2AfterModelDelete(lookup) {
    try {
      // Track whether any changes were made to chi2Terms
      let removedIds = [];

      setChi2Terms((oldTerms) => {
        const termsCopy = deepCopy(oldTerms);
        const updatedTerms = [];
        const remainingTermIds = [];

        // Guard against null/undefined terms
        if (!Array.isArray(termsCopy)) return termsCopy;

        for (let i = 0; i < termsCopy.length; i++) {
          const term = termsCopy[i];
          if (term && hasProperty(term, "modelId") && term.modelId in lookup) {
            updatedTerms.push(term);
            remainingTermIds.push(term.id);
          } else {
            removedIds.push(term.id);
          }
        }

        // Only update selected terms if we actually removed something
        if (removedIds.length > 0) {
          setSelectedChi2Terms((oldSelected) => {
            const updatedSelectedTerms = deepCopy(oldSelected);
            return updatedSelectedTerms.filter((id) =>
              remainingTermIds.includes(id)
            );
          });
        }
        return updatedTerms;
      });
    } catch (error) {
      recordedErrorLog("Chi2 term clearance failure: ", error);
    }
  }

  function unlinkModel(indexesToEl, inUnlinkLoop = false) {
    // using this function instead of setter because of useState setter delay -
    // the setter is setting the value in parallel to the main web app thread and
    // therefore it is not finished when delete function needs it
    try {
      const setNewNextID = (ID) => {
        idAfterUnlink = ID;
        currentID.current = ID;
        setModelNextID(ID);
      };

      const indexes = indexesToEl.split(";").map((char) => parseInt(char));
      const modelDataToUse = inUnlinkLoop
        ? deepCopy(modelsAfterUnlink)
        : deepCopy(modelData);
      const changed = unlinkModelList(
        modelDataToUse,
        indexes,
        modelNextID,
        setNewNextID,
        getAbbrDic,
        namingDic,
        setLocalAbbrDic,
        setNamingDic,
        indexesToEl
      );
      refreshLinks(changed);
      //same about delay here
      modelsAfterUnlink = deepCopy(changed);
      setModelData(changed);
      setCheckParamPositions(true);
    } catch (error) {
      recordedErrorLog("Model unlinking failure: ", error);
    }
  }

  function canLink(ID, speqqleID) {
    if (
      hasParentOrChildWithID(modelData, linkingID.current, speqqleID, ID) ||
      linkingID.current == ID ||
      speqqleID != linkingSpeqqleID.current
    ) {
      return false;
    } else {
      return true;
    }
  }

  function startLinking(ID, speqqleID, indexChain) {
    try {
      if (!linkingActive) {
        linkingID.current = ID;
        linkingSpeqqleID.current = speqqleID;

        const optionsForLinking = produceListOfExchangeableModels(
          modelData,
          linkingID.current,
          linkingSpeqqleID.current,
          indexChain
        );

        setLinkingOptions(optionsForLinking);
        setLinkingActive(true);
        setIsLinkOpen(true);
      } else {
        if (
          linkingID.current !== ID &&
          !hasParentOrChildWithID(
            modelData,
            linkingID.current,
            linkingSpeqqleID.current,
            ID
          ) &&
          speqqleID === linkingSpeqqleID.current
        ) {
          // Resets the model undo, since after linking, it's a step too far to undo the change
          setUndoModels((old) =>
            old.filter((oldModel) => oldModel.FE_ID !== linkingID.current)
          );

          const modelToBeReplaced = getModelById(linkingID.current, modelData);
          const modelFound = getModelById(ID, modelData);

          setLinked(modelFound);

          let modelDataToUse = modelData;

          let probableUpdate = null;
          probableUpdate = updateRecParamsAndRows(
            modelData,
            linkingID.current,
            modelFound,
            indexChain
          );

          if (probableUpdate !== null) {
            modelDataToUse = probableUpdate;
          }

          // Update valueGroups based on the before/after group changes from linking
          const updatedValueGroups = updateGroupsAfterLinking(
            valueGroups,
            modelToBeReplaced,
            modelFound
          );

          const replacedList = replaceModelById(
            modelDataToUse,
            modelFound,
            linkingID.current
          );

          setModelData(replacedList);
          setValueGroups(updatedValueGroups);
          setUpdatedModelFE_IDs((oldIDs) => {
            return [...oldIDs, linkingID.current];
          });
          const lookup = refreshLinks(replacedList);
          clearGraphsAfterModelDelete(lookup);
          clearChi2AfterModelDelete(lookup);
          setLinkingActive(false);
          // setLinkingID(null);
          linkingID.current = null;
        }
      }
    } catch (error) {
      recordedErrorLog("Linking initiation failure: ", error);
    }
  }

  function isLinkActive() {
    return linkingActive;
  }

  function addSubModel(ID, linked) {
    try {
      if (linked) {
        const newList = linkedSubModelAdd(
          addSubModTitle,
          modelData,
          ID,
          getID,
          allModels.current,
          upID,
          getAbbrDic,
          setLocalAbbrDic,
          namingDic,
          setNamingDic,
          recordedErrorLog,
          null,
          allLocalLineshapesRef.current,
          currentUser,
          sendJsonMessage
        );
        setModelData(newList);
        setUpdatedModelFE_IDs([ID]);
      } else {
        const newList = addSubModelToModels(
          addSubModTitle,
          modelData,
          ID,
          getID,
          allModels.current,
          upID,
          getAbbrDic,
          setLocalAbbrDic,
          namingDic,
          setNamingDic,
          null,
          recordedErrorLog,
          null,
          allLocalLineshapesRef.current,
          currentUser,
          sendJsonMessage
        );
        setModelData(newList);
        setUpdatedModelFE_IDs([ID]);
      }
    } catch (error) {
      recordedErrorLog("Sub model addition failure: ", error);
    }
  }

  const handleAddModel = () => {
    try {
      setModalIsOpen(true);

      const modalPosition = {
        top: modelsRef.current != null ? modelsRef.current.offsetTop : 0,
        right: "auto",
        left: vwToPixels(17),
      };
      const modalSize = { width: 285, height: 350 };

      const adjusted = adjustModalPositionAndSize(modalPosition, modalSize);

      setModalPlaceAndSize(adjusted);
    } catch (error) {
      recordedErrorLog("Model adding failure: ", error);
    }
  };


  const processFiles = async (files, attempt = 1) => {
    const maxAttempts = 3; // Attempt number in case allLocalModels is not loaded in yet
    const delayBetweenAttempts = 1500; // 1.5 seconds

    let jsonAndTxtFiles = [];
    //    let rfmFiles = [];

    try {
      // Separate the files into two lists: one for JSON and TXT, and another for RFM
      jsonAndTxtFiles = files.filter((file) => file.name.endsWith(".spqm"));
      // rfmFiles = files.filter(
      //   (file) => file.name.endsWith(".rfm") || file.name.endsWith(".RFM")
      // );
    } catch (error) {
      recordedErrorLog("Error separating files: ", error);
    }

    try {
      if (jsonAndTxtFiles.length > 0) {
        const filesData = await Promise.all(
          jsonAndTxtFiles.map((file) => simpleReadFile(file))
        );
        const parsedModels = getParsedModelListFromJson(filesData);

        // We select the first model in the file because we are always putting main model first when saving.
        const mainModel = parsedModels[0];

        if (allLocalModels.length > 0) {
          if (
            allLocalModels.some(
              (model) => model.speqqle_id === mainModel.modeltype
            )
          ) {
            const generatedModel = generateModelForParams(mainModel.modeltype);
            const updatedModel = loadExperimentFromFile(
              generatedModel,
              parsedModels,
              {
                allLocalLineshapes,
                generateModelForParams,
                limitedWarningToast,
                generateWarningObject,
                setWarnings,
                setNewWarningCount,
                recordedErrorLog,
              }
            );
            let localModelsDataCopy = deepCopy(localModelsDataRef.current);
            localModelsDataCopy.push(updatedModel);
            const oldValueGroups = deepCopy(valueGroups);
            const groupCheckResponse = updateGroupsOnModelChanges(
              localModelsDataCopy,
              oldValueGroups
            );
            if (hasProperty(groupCheckResponse, "clashingGroups") && groupCheckResponse.clashingGroups.length > 0) {
              setClashingModel(updatedModel);
              setClashingGroups(groupCheckResponse.clashingGroups);
              setUpdatedGroupsWithNoClash(groupCheckResponse.updatedValGroups);
            } else {
              localModelsDataRef.current = localModelsDataCopy;
              setModelData(localModelsDataCopy);
              if (hasProperty(groupCheckResponse, "updatedValGroups")) {
                setValueGroups(groupCheckResponse.updatedValGroups);
              }
            }
          } else {
            limitedToast("Model authentication issue.");
            generateWarningObject(
              "Your uploaded model could not be found in your subscribed model list. If you believe this is a mistake, please contact support.",
              2,
              setWarnings,
              setNewWarningCount
            );
          }
        } else {
          // This part is not really tested, because model loading is very very fast for now
          if (attempt < maxAttempts) {
            setTimeout(() => {
              processFiles(files, attempt + 1);
            }, delayBetweenAttempts);
          } else {
            limitedToast("Model authentication issue.");
            generateWarningObject(
              "Your uploaded model could not be found in your subscribed model list. Data took too long to load or there's another issue. If you believe this is a mistake, please contact support.",
              2,
              setWarnings,
              setNewWarningCount
            );
          }
        }
      }
    } catch (error) {
      recordedErrorLog("ERROR FILE PROCESS: ", error);
      limitedToast("Selected file could not be processed.");
      generateWarningObject(
        "Selected file could not be processed.",
        2,
        setWarnings,
        setNewWarningCount
      );
    }
    // } finally {
    //   if (rfmFiles && rfmFiles.length > 0) {
    //     processRfmFiles(rfmFiles);
    //   }

    //   if (fileInputRef.current) {
    //     fileInputRef.current.value = "";
    //   }
    // }
  };

  // const processRfmFiles = async (rfmFiles) => {
  //   try {
  //     const rfmData = await Promise.all(
  //       rfmFiles.map((file) => simpleReadFile(file))
  //     );

  //     const sendModel = [];
  //     const requestedIds = [];

  //     // Handle RFM file processing logic here
  //     rfmData.forEach((fileData) => {
  //       const base64Content = arrayBufferToBase64(fileData.content);
  //       const newIdForModel = getID();
  //       // requestedBinary.current = [...requestedBinary.current, newIdForModel];
  //       requestedIds.push(newIdForModel);
  //       upID();
  //       sendModel.push({
  //         modelid: newIdForModel,
  //         binary: base64Content,
  //       });
  //     });

  //     const payload = {
  //       User: currentUser.id,
  //       Model: {
  //         SendModel: sendModel,
  //       },
  //     };
  //     sendJsonMessage(payload, {
  //       type: "binary-model-load",
  //       requestedIds: requestedIds,
  //     });
  //   } catch (error) {
  //     recordedErrorLog("ERROR RFM FILE PROCESS: ", error);
  //     limitedToast("Selected RFM file could not be processed.");
  //     generateWarningObject(
  //       "Selected RFM file could not be processed.",
  //       2,
  //       setWarnings,
  //       setNewWarningCount
  //     );
  //   }
  // };

  function getModelFromFromFilesById(FE_ID, listOfParsedModels, speqqleId) {
    try {
      const generatedModel = generateModelForParams(speqqleId);
      let foundModel = listOfParsedModels.find(
        (parsedModel) => parsedModel.modelid === FE_ID
      );
      foundModel = convertModelFormat(foundModel);
       if (foundModel !== undefined) {
        const getRelevantSubModel = (speqqleId, FE_ID) => {
          const foundSubModel = getModelFromFromFilesById(
            FE_ID,
            listOfParsedModels,
            speqqleId
          );

          return foundSubModel;
        };

        const updatedModel = createModelFromParamList(
          foundModel,
          generatedModel,
          getRelevantSubModel,
          sendJsonMessage,
          currentUser,
          allLocalLineshapes
        );
        return updatedModel;
      } else {
        limitedWarningToast("Couldn't find sub model.");
        generateWarningObject(
          "Could not find required sub model in loaded in file, using default one instead.",
          1,
          setWarnings,
          setNewWarningCount
        );

        return generatedModel;
      }
    } catch (error) {
      recordedErrorLog("Issue with getting loaded sub models: ", error);
    }
  }

  const addModelEntryFromFile = (modelFromFile) => {
    try {
      // Function to recursively check for groups in a model and its submodels
      const checkForGroups = (model) => {
        let hasGroups = false;

        // Check non-recuring parameters
        if (model.modelParams) {
          for (let i = 0; i < model.modelParams.length; i++) {
            const param = model.modelParams[i];
            if (hasProperty(param, "group")) {
              hasGroups = true;
              break;
            }
          }
        }

        // Check recuring parameters
        if (!hasGroups && hasProperty(model, "recParams")) {
          for (let i = 0; i < model.recParams.length; i++) {
            const paramRow = model.recParams[i];
            for (let j = 0; j < paramRow.length; j++) {
              const param = paramRow[j];
              if (hasProperty(param, "group")) {
                hasGroups = true;
                break;
              }
            }
            if (hasGroups) break;
          }
        }

        // Check lineshape parameters
        if (!hasGroups && hasProperty(model, "lineshapeData")) {
          for (let i = 0; i < model.lineshapeData.length; i++) {
            for (let j = 0; j < model.lineshapeData[i].lineParams.length; j++) {
              for (
                let k = 0;
                k < model.lineshapeData[i].lineParams[j].length;
                k++
              ) {
                if (
                  hasProperty(model.lineshapeData[i].lineParams[j][k], "group")
                ) {
                  hasGroups = true;
                  break;
                }
              }
              if (hasGroups) break;
            }
            if (hasGroups) break;
          }
        }

        // Recursively check submodels
        if (
          !hasGroups &&
          hasProperty(model, "subModels") &&
          model.subModels.length > 0
        ) {
          for (let i = 0; i < model.subModels.length; i++) {
            hasGroups = checkForGroups(model.subModels[i]);
            if (hasGroups) break;
          }
        }

        return hasGroups;
      };

      // Function to recursively collect clashing groups from a model and its submodels
      const collectAllClashingGroups = (
        model,
        valueGroups,
        clashingGroups,
        groupsUpdate
      ) => {
        // Check non-recurring parameters
        const checkedNonRecParams = collectClashingGroupsFromNonRecParams(
          model,
          valueGroups,
          clashingGroups,
          groupsUpdate
        );
        clashingGroups = checkedNonRecParams.clashingGroups;
        groupsUpdate = checkedNonRecParams.groupsUpdate;

        // Check recurring parameters
        const checkedRecParams = collectClashingGroupsFromRecParams(
          model,
          valueGroups,
          clashingGroups,
          groupsUpdate
        );
        clashingGroups = checkedRecParams.clashingGroups;
        groupsUpdate = checkedRecParams.groupsUpdate;

        // Check lineshape parameters
        const checkedLineshapes = collectClashingGroupsLineshapes(
          model,
          valueGroups,
          clashingGroups,
          groupsUpdate
        );
        clashingGroups = checkedLineshapes.clashingGroups;
        groupsUpdate = checkedLineshapes.groupsUpdate;

        // Recursively check submodels
        if (hasProperty(model, "subModels") && model.subModels.length > 0) {
          for (let i = 0; i < model.subModels.length; i++) {
            const result = collectAllClashingGroups(
              model.subModels[i],
              valueGroups,
              clashingGroups,
              groupsUpdate
            );
            clashingGroups = result.clashingGroups;
            groupsUpdate = result.groupsUpdate;
          }
        }

        return { clashingGroups, groupsUpdate };
      };

      const hasGroups = checkForGroups(modelFromFile);

      if (hasGroups) {
        let clashingGroups = {};
        let groupsUpdate = deepCopy(valueGroups);

        // Collect all clashing groups recursively
        const result = collectAllClashingGroups(
          modelFromFile,
          valueGroups,
          clashingGroups,
          groupsUpdate
        );

        clashingGroups = result.clashingGroups;
        groupsUpdate = result.groupsUpdate;

        const clashingGroupNumbers = Object.keys(clashingGroups);

        // We check here if there are any values loaded in that have clashing groups
        if (clashingGroupNumbers.length > 0) {
          // We found that there are clashing groups and we will have to initiate merging procedure
          setClashingModel(modelFromFile);
          setClashingGroups(clashingGroups);
          setUpdatedGroupsWithNoClash(groupsUpdate);
        } else {
          // We have no clashing groups here, so we can proceed with adding the model
          // const generatedModel = generateModelFromFile(
          //   modelFromFile,
          //   getID,
          //   upID,
          //   getAbbrDic,
          //   setLocalAbbrDic,
          //   namingDic,
          //   setNamingDic
          // );
          const modelDataToChange = deepCopy(localModelsDataRef.current);
          modelDataToChange.push(modelFromFile);
          setModelData(deepCopy(modelDataToChange));
          setValueGroups(groupsUpdate);
        }
      } else {
        // const generatedModel = generateModelFromFile(
        //   modelFromFile,
        //   getID,
        //   upID,
        //   getAbbrDic,
        //   setLocalAbbrDic,
        //   namingDic,
        //   setNamingDic
        // );
        const modelDataToChange = deepCopy(localModelsDataRef.current);
        modelDataToChange.push(modelFromFile);
        setModelData(modelDataToChange);
      }
    } catch (error) {
      recordedErrorLog("Adding model from file has failed: ", error);
    }
  };

  const handleLoadModel = () => {
    fileInputRef.current.click();
  };

  // Loaded model Clashing solutions:
  // Reject
  function rejectClash() {
    resetClashModal();
  }

  // Solve
  function solveClash(updatedValGroups, uploadedModel) {
    try {
      // Updating model after solving the clash
      // const generatedModel = generateModelFromFile(
      //   uploadedModel,
      //   getID,
      //   upID,
      //   getAbbrDic,
      //   setLocalAbbrDic,
      //   namingDic,
      //   setNamingDic,
      //   false
      // );
      const generatedModel = uploadedModel;
      const modelDataToChange = deepCopy(localModelsDataRef.current);
      modelDataToChange.push(generatedModel);
      setValueGroups(updatedValGroups);
      // UPDATE MODELS WITH LATEST GROUP CHANGE!
      const updatedModelsObj = updateModelsOnGroupChanges(
        modelDataToChange,
        updatedValGroups
      );
      setUpdatedModelFE_IDs((oldIDS) => {
        return [...oldIDS, ...updatedModelsObj.updatedIds];
      });

      setModelData(updatedModelsObj.udpatedModels);
      resetClashModal();
    } catch (error) {
      recordedErrorLog("Clash solving has failed: ", error);
    }
  }

  function resetClashModal() {
    handleCloseClashModal();
    setClashingModel(null);
    setClashingGroups(null);
  }

  return (
    <div className="models" ref={modelsRef}>
      <div className="modelsButtonSection">
        {isAuthReady &&
        currentUser.email !== "demo@speqqle.com" &&
        currentUser.email !== "zbjdnmgrklqkaeumso@cwmxc.com" ? (
          <>
            <CustomButton
              text="Add New Experiment"
              extraClassnames={["modelLoaderButton"]}
              handleClick={handleAddModel}
              id="add-model-button"
              disabled={isFitOngoing || isLoopOngoing}
            />
            <CustomButton
              text="Load Experiment"
              extraClassnames={["modelLoaderButton"]}
              handleClick={handleLoadModel}
              id="load-model-button"
              disabled={isFitOngoing || isLoopOngoing}
            />
            <input
              ref={fileInputRef}
              type="file"
              accept=".spqm" //,.rfm"
              onChange={(e) =>
                //handleFileChange(e, ["spqm", "rfm", "RFM"], processFiles)
                handleFileChange(e, ["spqm"], processFiles)
              }
              style={{ display: "none" }}
              data-testid="model-file-input"
            />
            <CustomButton
              text="Material Database"
              extraClassnames={["modelLoaderButton"]}
              handleClick={handleOpenMaterialDB}
              id="material-db-button"
              disabled={isFitOngoing || isLoopOngoing}
            />
          </>
        ) : (
          <div className="demoOnlyWarning" id="restricted-model-load-demo">
            Custom Model loading is for premium users only.
          </div>
        )}
      </div>
      {linkingActive ? (
        <div className="linkingNote">Click on another model to link</div>
      ) : (
        <></>
      )}
      {/* <div className="modelList">{modelsForDisplay}</div> */}
      <div className="modelList" ref={modelListRef}>
        {modelsToDisplay}
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        contentLabel="Model Modal"
        appElement={modelsRef.current}
        style={{
          content: {
            width: modalPlaceAndSize.width,
            height: modalPlaceAndSize.height,
            top: modalPlaceAndSize.top,
            left: modalPlaceAndSize.left,
            right: modalPlaceAndSize.right,
          },
          overlay: {
            backgroundColor: "transparent",
            zIndex: "9000",
          },
        }}
      >
        <div className="modalList" id="load-model-list">
          {!loading &&
          allModels.current != null &&
          allModels.current.length > 0 ? (
            modalList
          ) : allModels.current != null && allModels.current.length === 0 ? (
            <div>
              You currently have no access to any models. Please subscribe for a
              package or contact an admin.
            </div>
          ) : (
            <div>Loading ...</div>
          )}
        </div>
      </Modal>
      <Modal
        isOpen={clashModalIsOpen}
        onRequestClose={handleCloseClashModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Clashing Modal"
        appElement={modelsRef.current}
        id="clashModal"
        style={{
          content: {
            width: "80vw",
            height: "60vh",
            top: `20%`,
            left: "10%",
            right: "auto",
          },
          overlay: {
            zIndex: "8000",
          },
        }}
      >
        <GroupClashWindow
          clashingGroups={clashingGroups}
          clashingModel={clashingModel}
          valueGroups={upadatedGroupsWithNoClash}
          solveClash={solveClash}
          rejectClash={rejectClash}
        />
      </Modal>
      <ModelExchange
        componentRef={modelListRef}
        isOpen={isLinkOpen}
        setIsOpen={setIsLinkOpen}
        listOfOptions={linkingOptions}
        handleModelExchange={startLinking}
        isLinking
      />
      <MaterialDBModal
        isOpen={materialDBModalIsOpen}
        onClose={handleCloseMaterialDB}
        appElement={modelsRef.current}
        getModelFromFromFilesById={getModelFromFromFilesById}
        addModelEntryFromFile={addModelEntryFromFile}
      />
      {isFitOngoing || isLoopOngoing ? <BlockingOverlay /> : <></>}
    </div>
  );
}
